import { Directive, ElementRef, Input } from '@angular/core';

/*
 * Massively inspired by https://codepen.io/vsync/pen/frudD
 * and https://github.com/angular/material/blob/master/src/components/input/input.js
 *
 * Note that there must be an [model] attribute on the textarea to trigger the updates
 */
@Directive({
  selector: '[appTextareaAutoExpand]',
})
export class TextareaAutoExpandDirective {
  private MAX_ROWS = 5; // Hardcode it for now, as we only have one textarea in the app anyway

  private lineHeight = null;
  ta: HTMLTextAreaElement;

  constructor(elRef: ElementRef) {
    this.ta = elRef.nativeElement;
    this.ta.rows = 1;
  }

  @Input() set model(value: string) {
    if (value !== undefined) {
      this.updateRows();
    }
  }

  updateRows() {
    this.ta.rows = 1;
    this.ta.style.minHeight = '0';

    if (!this.lineHeight) {
      // this.lineHeight will be null the first time this is called,
      // and 0 if called when the textarea is not displayed (this happens with IE11 at least)
      this.ta.style.padding = '0';
      this.lineHeight = this.ta.clientHeight;
      // console.log('TextareaAutoExpandDirective - set this.lineHeight to ' + this.lineHeight);
      this.ta.style.padding = '';
    }
    if (this.lineHeight) {
      // clientHeight is 1 line + padding, scrollHeight is all lines + padding
      const lines = 1 + Math.round((this.ta.scrollHeight - this.ta.clientHeight) / this.lineHeight);
      // console.log(`scrollHeight is ${this.ta.scrollHeight}, clientHeight is ${this.ta.clientHeight}; seems to be ${lines} lines`);
      const rows = Math.min(lines, this.MAX_ROWS);
      this.ta.rows = rows;

      // IE11's flex imlpementation seems a little lost here, let's try to work around it
      setTimeout(() => {
        this.ta.style.minHeight = `${this.lineHeight * rows}px`;
      });
    }
  }
}
